import { getFormattedMonth } from '../../utils/date';
const MILLION = 1000000;
export const formatRevenue = (num) => {
    if (num == null) {
        return '';
    }
    if (num < 1000) {
        return String(num);
    }
    if (num >= 1000 && num < 1000000) {
        return `$${Math.trunc(num / 1000)}K`;
    }
    if (num >= 1000000 && num < 1000000000) {
        return `$${Math.trunc(num / 1000000)}M`;
    }
    if (num >= 1000000000 && num < 10000000000) {
        return `$${Math.trunc(num / 1000000000)}B`;
    }
    if (num >= 10000000000 && num < 100000000000) {
        return `$${Math.trunc(num / 10000000000)}0B`;
    }
    if (num >= 100000000000 && num < 1000000000000) {
        return `$${Math.trunc(num / 100000000000)}00B`;
    }
    if (num >= 1000000000000) {
        return '$100B+';
    }
    return '';
};
export const getRevenueRangeString = (revenueRange) => {
    if (!revenueRange) {
        return '';
    }
    const { min, max } = revenueRange;
    if (min && max) {
        return `${formatRevenue(min)} to ${formatRevenue(max)}`;
    }
    if (min || max) {
        return formatRevenue(min || max);
    }
    return '';
};
const formatFundingDate = (fundingDate) => {
    if (!fundingDate) {
        return '';
    }
    const dateValues = fundingDate.split('-');
    const fundingYear = dateValues[0];
    const fundingMonth = String(getFormattedMonth(fundingDate));
    const fundingDay = dateValues[2];
    return `${fundingMonth} ${fundingDay}, ${fundingYear}`;
};
export const formatFundingSummary = (fundingSummary) => {
    const summary = fundingSummary;
    if (!(summary === null || summary === void 0 ? void 0 : summary.value)) {
        return null;
    }
    const { total_fund_events: numberOfFundingRounds = null, value: totalFunding, last_funding_round_usd: lastFundingAmount, value_usd: totalFundingInUsd, last_funding_round_name: lastFundingName = null, ipo_date: fundingDate, } = summary;
    return {
        fundingDate: formatFundingDate(fundingDate),
        numberOfFundingRounds,
        lastFundingAmount: Math.floor(Number(lastFundingAmount) / MILLION),
        totalFunding: Math.floor((totalFundingInUsd || totalFunding) / MILLION),
        lastFundingName,
    };
};
